import { Action, State, StateContext } from '@ngxs/store';
import { AuthenticationMethod } from './authentication-method';
import * as Api from '../../../generated/swagger';
import { MicrosoftEntraIdAuthenticationSettings } from './microsoft-entra-id-authentication-settings';
import { Injectable } from '@angular/core';
import { RequestAuthenticationSettings } from './authentication-settings.actions';
import { tap } from 'rxjs/operators';
import _ from 'lodash';

export interface AuthenticationSettingsStateModel {
   authenticationMethod: AuthenticationMethod;
   microsoftEntraIdAuthenticationSettings?: MicrosoftEntraIdAuthenticationSettings;
}

@State<AuthenticationSettingsStateModel>({
   name: 'authenticationSettings',
   defaults: {
      authenticationMethod: AuthenticationMethod.Samwin,
      microsoftEntraIdAuthenticationSettings: null,
   },
})
@Injectable()
export class AuthenticationSettingsState {
   constructor(private sessionsService: Api.SessionsService) {}

   @Action(RequestAuthenticationSettings)
   public RequestAuthenticationSettings(ctx: StateContext<AuthenticationSettingsStateModel>, action: RequestAuthenticationSettings) {
      return this.sessionsService.getAuthenticationSettings().pipe(
         tap((response) => {
            let authenticationMethod = AuthenticationMethod.Samwin;
            if (response.authenticationMethod === Api.AuthenticationMethod.Domain) {
               authenticationMethod = AuthenticationMethod.Domain;
            } else if (response.authenticationMethod === Api.AuthenticationMethod.MicrosoftEntraId) {
               authenticationMethod = AuthenticationMethod.MicrosoftEntraId;
            }

            let microsoftEntraIdAuthenticationSettings: MicrosoftEntraIdAuthenticationSettings = null;
            if (!_.isNil(response.microsoftEntraIdAuthenticationSettings)) {
               const portString = window.location.port ? `:${window.location.port}` : '';
               microsoftEntraIdAuthenticationSettings = {
                  appClientId: response.microsoftEntraIdAuthenticationSettings.appClientId,
                  authority: response.microsoftEntraIdAuthenticationSettings.authority,
                  redirectUri: `${window.location.protocol}//${window.location.hostname}${portString}/assets/microsoft-entra-id/blank.html`,
                  cacheLocation: 'sessionStorage',
               };
            }

            ctx.patchState({
               authenticationMethod: authenticationMethod,
               microsoftEntraIdAuthenticationSettings: microsoftEntraIdAuthenticationSettings,
            });
         })
      );
   }
}
